import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
  Navigate,
} from "react-router-dom";
import Layout from "./Layout";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import PintaTerms from "./pages/PintaTerms";
import PintaPolicy from "./pages/PintaPolicy";
import Pinta from "./pages/Pinta";
import PintaHelp from "./pages/PintaHelp";

function App() {
  return (
    <Router>
      <Routes>
        {/* Redirección inicial según idioma o localStorage */}
        <Route path="/" element={<LanguageRedirect />} />

        {/* Rutas con idioma */}
        <Route
          path="/:lang/home"
          element={
            <Layout>
              <Home />
            </Layout>
          }
        />
        <Route
          path="/:lang/pinta"
          element={
            <Layout>
              <Pinta />
            </Layout>
          }
        />
        <Route
          path="/:lang/pinta/terms"
          element={
            <Layout>
              <PintaTerms />
            </Layout>
          }
        />
        <Route
          path="/:lang/pinta/privacy"
          element={
            <Layout>
              <PintaPolicy />
            </Layout>
          }
        />
        <Route
          path="/:lang/pinta/help"
          element={
            <Layout>
              <PintaHelp />
            </Layout>
          }
        />
        <Route
          path="/:lang/privacy"
          element={
            <Layout>
              <PrivacyPolicy />
            </Layout>
          }
        />
        <Route
          path="/:lang/contact"
          element={
            <Layout>
              <Contact />
            </Layout>
          }
        />

        {/* Si se accede a una ruta no existente, redirigimos a raíz */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

const LanguageRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Idiomas disponibles
    const availableLangs = ["es", "en", "fr", "de", "it"];

    // 1. Primero revisamos si el usuario tiene un idioma preferido en localStorage
    const storedLang = localStorage.getItem("preferredLang");
    if (storedLang && availableLangs.includes(storedLang)) {
      navigate(`/${storedLang}/home`, { replace: true });
      return;
    }

    // 2. Si no hay preferencia guardada, detectamos idioma del navegador
    const browserLang = (
      navigator.language || navigator.userLanguage
    ).toLowerCase();

    // 3. Determinamos el idioma según el prefijo; si no coincide, caemos a 'en'
    let langPrefix = "en"; // Idioma por defecto si no coincide ninguno
    if (browserLang.startsWith("es")) {
      langPrefix = "es";
    } else if (browserLang.startsWith("fr")) {
      langPrefix = "fr";
    } else if (browserLang.startsWith("de")) {
      langPrefix = "de";
    } else if (browserLang.startsWith("it")) {
      langPrefix = "it";
    } else if (browserLang.startsWith("en")) {
      langPrefix = "en";
    }

    navigate(`/${langPrefix}/home`, { replace: true });
  }, [navigate]);

  return null;
};

export default App;
